import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { useLocalUserPreference } from '@percent/cause-dashboard/common/hooks/useLocalUserPreference/useLocalUserPreference'
import { config } from '@percent/cause-dashboard/config'

// Exported for the MSW handler
export const GEOLOCATION_URL = 'https://api.ipgeolocation.io/ipgeo'

const FALLBACK_COUNTRY_CODE_ISO3 = 'GBR'
// ipgeolocation's terms allow caching a result for 24 hours at most
const CACHE_EXPIRATION_HOURS = 24
const TIMEOUT = 3 * 1000

type GeolocationResponse = {
  country_code3?: string
}

interface IMyCountryFromIp {
  forceIp?: string
  useLocalCache?: boolean
}

export const useMyCountryFromIp = (props?: IMyCountryFromIp) => {
  const { forceIp, useLocalCache } = props || {}
  const [cacheCountry, setMyCountryInCache] = useLocalUserPreference('country')
  const [country, setCountry] = useState<string | null>(useLocalCache ? cacheCountry : null)

  const fetchCountry = useCallback(async () => {
    if (country) {
      return
    }

    try {
      const { data } = await axios.get<GeolocationResponse>(GEOLOCATION_URL, {
        params: { apiKey: config.keys.geolocation || undefined, ip: forceIp },
        timeout: TIMEOUT
      })

      if (!data.country_code3) {
        throw new Error('No country in geolocation response')
      }

      setCountry(data.country_code3)
      setMyCountryInCache(data.country_code3, {
        expiresInHours: CACHE_EXPIRATION_HOURS
      })
    } catch {
      setCountry(FALLBACK_COUNTRY_CODE_ISO3)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    void fetchCountry()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    country: country
  }
}
